/* global window, document, pymChild */

import './styles/graphic.scss';
import { Child } from 'pym.js';
import mapboxgl from 'mapbox-gl';
// import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';         // uncomment for geocoder
// import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css'; // this too
import 'regenerator-runtime/runtime';

import mapdata from './data/route.json';
import mapdata_area from './data/area.json';


// //// For locator map pins
const label_list = [
  {
    text: 'Atacante en el techo',
    lngLat: [-87.80119813978672,
      42.18520562057211],
    orientation: 'nw',
    style: 'red',
  },
  {
    text: 'Inicio desfile',
    lngLat: [-87.79784202575684, 42.18466502970747],
    orientation: 's',
    style: 'black',
  },
  {
    text: 'Fin desfile',
    lngLat: [-87.80598521232604, 42.18332943245995],
    orientation: 's',
    style: 'regular',
  },
];

// ////// ENTER details for map styles
const config = {
  style: 'mapbox://styles/cnndigital/ckml1xs3z0y4317rm0q42lmrp',
  default_zoom: 15.1,
  default_center: [-87.8020, 42.18446],
  // default_center: label_list[0].lngLat,
};

const translator = {
  n: {
    class: 'top',
    anchor: 'bottom',
    offset: 10,
  },
  s: {
    class: 'bottom',
    anchor: 'top',
    offset: 10,
  },
  w: {
    class: 'left',
    anchor: 'right',
    offset: 10,
  },
  e: {
    class: 'right',
    anchor: 'left',
    offset: 10,
  },
  se: {
    class: 'bottomright',
    anchor: 'top-left',
    offset: 14,
  },
  sw: {
    class: 'bottomleft',
    anchor: 'top-right',
    offset: 14,
  },
  ne: {
    class: 'topright',
    anchor: 'bottom-left',
    offset: 14,
  },
  nw: {
    class: 'topleft',
    anchor: 'bottom-right',
    offset: 14,
  },
}; // # Import local data

// Mapbox
mapboxgl.accessToken = 'pk.eyJ1IjoiY25uZGlnaXRhbCIsImEiOiJiYjIwMTgxNDZmNjgyODllMjAxYTYwOTAxYmY2MzI2MyJ9.8F6TQITXymFzCXy8tBqGgg';
let mapParams;
let hasLocation;

// instantiate pym object
window.pymChild = new Child();

// check for URL params
function checkParams() {
  const url = window.location.href;

  // Parse params
  const getParams = function (url) {
    const params = {};
    const parser = document.createElement('a');
    parser.href = url;
    const query = parser.search.substring(1);
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split('=');
      params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return params;
  };

  mapParams = getParams(url);
  if ('lnglat' in mapParams) {
    mapParams.lnglat = [parseFloat(mapParams.lnglat.split(',')[0]), parseFloat(mapParams.lnglat.split(',')[1])];
  }
  if ('z' in mapParams) {
    mapParams.z = parseFloat(mapParams.z);
  }
  if ('l' in mapParams) {
    mapParams.l = mapParams.l.split(',');
  }

  // Set params to true if they have what we want (zoom + lng/lat)
  hasLocation = !!('lnglat' in mapParams && 'z' in mapParams);
}

export default function (props, container, isMobile) {
  // function to draw the map
  const drawMap = () => {
    const {
      initialWidth,
      initialHeight,
      // width,
      // height
    } = props;

    checkParams();

    // complicated way to adjust the zoom depending on the
    // map size. could use more elegance.
    function getZoom() {
      let zoomLevel;
      if (hasLocation) {
        zoomLevel = isMobile ? mapParams.z - 1 : mapParams.z;
      } else if (initialWidth >= 900) {
        zoomLevel = config.default_zoom + 0.25;
      } else if (initialWidth < 640 && initialWidth > 630) {
        zoomLevel = 3.05;
      // } else if (initialWidth <= 320) {
      //   zoomLevel = 2;
      } else {
        zoomLevel = isMobile ? config.default_zoom - 1.3 : config.default_zoom;
      }
      return zoomLevel;
    }

    const map_bounds = [
      [-126.79845, 20.933235], // SW coordinates
      [-54.12246, 47.5733], // NE coordinates
    ];

    // // -- Map drawing -- // //

    // Draw the map
    container.append('div')
      .attr('class', 'map-container')
      .append('div')
      .attr('id', 'map')
      .attr('width', initialWidth)
      .attr('height', initialHeight);

    const map = new mapboxgl.Map({
      container: 'map',
      style: config.style,
      projection: { name: 'albers' },
      center: hasLocation ? mapParams.lnglat : config.default_center,
      zoom: getZoom(),
      maxZoom: 18,
      minZoom: 2,
      maxBounds: map_bounds,
      pitchWithRotate: false,
      scrollZoom: false,
      dragRotate: false,
      touchPitch: false,
      interactive: true,
      cooperativeGestures: true,
    });

    // ///// Optional Geocoder Box Block //////
    //     const map = new mapboxgl.Map({
    //   container: 'graphic',
    //   style: 'mapbox://styles/cnndigital/ckml1xs3z0y4317rm0q42lmrp',
    //   projection: { name: 'albers' },
    //   center: [-95.7129, 37.0902],
    //   zoom: 4,
    //   minZoom: 3,
    //   maxBounds: [[-167.874050, 18.026749], [-64.675719, 49.95]],
    //   boxZoom: true,
    // });
    //
    // const geocoder = new MapboxGeocoder({
    //   accessToken: mapboxgl.accessToken,
    //   mapboxgl,
    //   marker: false,
    //   countries: 'us',
    //   placeholder: 'Search your location',
    //   zoom: 16,
    //   bbox: [-145.6, 17.2, -58.5, 53.5],
    //   types: 'address,neighborhood,locality,place,district,postcode,region',
    //   filter(item) {
    //     return item.context
    //       .map(i => i.id.split('.').shift() === 'country' && i.text === 'United States')
    //       .reduce((acc, cur) => acc || cur);
    //   },
    // });
    //
    // map.addControl(
    //   geocoder,
    // );
    //
    // geocoder.on('result', (e) => {
    //   if (e == null || e == undefined) {
    //     // do something here
    //     console.log('no results to geocoding');
    //   } else {
    //     const lat = e.result.center[1];
    //     const lng = e.result.center[0];
    //
    //     const usrState = {
    //       coords: {
    //         lat,
    //         lng,
    //         place_type: e.result.place_type[0],
    //       },
    //     };
    //
    //     let zoom_to;
    //     if (usrState.coords.place_type == 'region') {
    //       zoom_to = 5;
    //     } else {
    //       zoom_to = 9;
    //     }
    //
    //     // move map here!
    //     console.log(usrState.coords);
    //     map.jumpTo({
    //       center: [usrState.coords.lng, usrState.coords.lat],
    //       zoom: zoom_to,
    //     });
    //   }
    // });

    map.on('load', () => {
      pymChild.sendHeight();

      // zoom buttons
      map.addControl(new mapboxgl.NavigationControl({
        showCompass: false,
      }), 'top-right');

      // scale
      map.addControl(new mapboxgl.ScaleControl({
        maxWidth: 100,
        unit: 'imperial',
      }), 'top-left');


      // /// custom US button /// //

      /* Idea from Stack Overflow https://stackoverflow.com/a/51683226  */
      // class MapboxGLButtonControl {
      //   constructor({
      //     className = '',
      //     title = '',
      //     eventHandler = evtHndlr,
      //   }) {
      //     this._className = className;
      //     this._title = title;
      //     this._eventHandler = eventHandler;
      //   }

      //   onAdd(map) {
      //     this._btn = document.createElement('button');
      //     this._btn.className = `${'mapboxgl-ctrl-icon' + ' '}${this._className}`;
      //     this._btn.type = 'button';
      //     this._btn.title = this._title;
      //     this._btn.onclick = this._eventHandler;

      //     this._container = document.createElement('div');
      //     this._container.className = 'mapboxgl-ctrl-group mapboxgl-ctrl';
      //     this._container.appendChild(this._btn);

      //     return this._container;
      //   }

      //   onRemove() {
      //     this._container.parentNode.removeChild(this._container);
      //     this._map = undefined;
      //   }
      // }

      // /* Event Handlers */
      // function usButtonClick() {
      //   map.jumpTo({
      //     center: defaultCenter,
      //     zoom: getZoom(),
      //   });
      // }

      // /* Instantiate new controls with custom event handlers */
      // const usHome = new MapboxGLButtonControl({
      //   className: 'mapbox-gl-us-home',
      //   title: 'US Home',
      //   eventHandler: usButtonClick,
      // });

      // if (isMobile) {
      //   map.addControl(usHome, 'top-left');
      // } else {
      //   map.addControl(usHome, 'top-right');
      // }


      // // -- load data layer here -- // //

      // // Example using local geojson and opacity fill
      // map.addSource('areabox', {
      //   type: 'geojson',
      //   data: mapdata_area,
      // });

      // map.addLayer({
      //   id: 'areabox',
      //   source: 'areabox',
      //   type: 'fill',
      //   paint: {
      //     'fill-color': 'rgba(204, 0, 0, 0.3)',
      //   },

      // // Layer in the style stack under which this layer should be drawn
      // // (We're using waterway-label, which is below all the state and city names)
      // }, 'waterway-label');

      // // Example using local geojson data (mapdata)
      // map.addSource('gauges', {
      //   type: 'geojson',
      //   data: mapdata,
      // });
      //
      // map.addLayer({
      //   id: 'gauges',
      //   source: 'gauges',
      //   type: 'circle',
      //   paint: {
      //     'circle-color': ['get', 'fill'],
      //     'circle-radius': 6,
      //     'circle-opacity': 0.9,
      //   },
      //
      // // Layer in the style stack under which this layer should be drawn
      // // (We're using waterway-label, which is below all the state and city names)
      // }, 'waterway-label');

      // Example using linestrings in geojson
      map.addSource('route', {
        type: 'geojson',
        data: mapdata,
      });

      map.addLayer({
        id: 'route',
        source: 'route',
        type: 'line',
        paint: {
          'line-color': '#0c0c0c',
          'line-width': 4,
          'line-opacity': 0.8,
        },

      // Layer in the style stack under which this layer should be drawn
      // (We're using waterway-label, which is below all the state and city names)
      }, 'airport-label');

      // // Example using a polygon vector tile layer
      // map.addSource('snow', {
      //   type: 'vector',
      //   url: 'mapbox://cnndigital.snow_inches',
      //   maxzoom: 24,
      //   minzoom: 0,
      // });
      //
      // map.addLayer({
      //   id: 'snow',
      //   source: 'snow',
      //   'source-layer': 'us_snow_forecast_v1',
      //   type: 'fill',
      //   layout: { visibility: 'visible' },
      //   paint: {
      //     'fill-color': ['get', 'fill'],
      //     'fill-opacity': 1,
      //   },
      //
      //   // Layer in the style stack under which this layer should be drawn
      //   // (We're using waterway-label, which is below all the state and city names)
      // }, 'state-innerlines');


      // // Example using point data in vector tiles
      // map.addSource('stations', {
      //   type: 'vector',
      //   url: 'mapbox://cnndigital.white_xmas',
      // });
      //
      // map.addLayer({
      //   id: 'stations',
      //   source: 'stations',
      //   'source-layer': 'white_xmas',
      //   type: 'circle',
      //   paint: {
      //     'circle-color': '#ffffff',
      //     'circle-radius': {
      //       base: 1,
      //       stops: [
      //         [4, 0],
      //         [5, 2],
      //         [7, 10],
      //       ],
      //     },
      //     'circle-opacity': 0.9,
      //     'circle-stroke-width': 0.5,
      //     'circle-stroke-color': '#000000',
      //
      //   },
      //
      // // Layer in the style stack under which this layer should be drawn
      // // (We're using waterway-label, which is below all the state and city names)
      // }, 'waterway-label');


      // // Example using raster tiles
      // // Note, this forces mapbox-gl to load raster tiles as PNGs to preserve transparency.
      // // (Safari will use JPGs otherwise, and 'transparent' areas will show up black.)
      // // For more troubleshooting, see: https://docs.mapbox.com/help/troubleshooting/raster-transparency-issues/
      // map.addSource('noaa_map', {
      //   type: 'raster',
      //   tiles: [
      //     `https://api.mapbox.com/v4/cnndigital.7d5hl52y/{z}/{x}/{y}.png?access_token=${mapboxgl.accessToken}`,
      //   ],
      // });
      //
      // map.addLayer({
      //   id: 'raster-layer',
      //   type: 'raster',
      //   source: 'noaa_map',
      //   minzoom: 0,
      //   maxzoom: 8,
      // }, 'road-simple');
    });

    // / add locator map pins
    const makePopup = (label, lngLat, orientation, style) => {
      new mapboxgl.Popup({
        closeOnClick: false,
        closeButton: false,
        className: `map-label-pin-${translator[orientation].class}`,
        anchor: translator[orientation].anchor,
        offset: translator[orientation].offset,
      })
        .setLngLat(lngLat)
        .setHTML(label)
        .addClassName((style == 'callout' || style == 'red') ? 'map-label-callout' : '')
        .addTo(map);
    };

    label_list.forEach((label) => {
      makePopup(label.text, label.lngLat, label.orientation, label.style);
    });

    map.on('idle', () => {
      const current_lon = map.getCenter().lng;
      const current_lat = map.getCenter().lat;
      const current_zoom = map.getZoom();
      console.log(`lngLat: [${current_lon.toFixed(4)}, ${current_lat.toFixed(6)}]  zoom: ${current_zoom.toFixed(2)}`);
    });

    // update height of svg to pym
    pymChild.sendMessage('height', initialHeight);

    // a second later send a confidence height ... just to be sure
    setTimeout(() => { pymChild.sendHeight(); }, 1000);
  };

  // // -- Launch map -- // //

  drawMap();
}
